import request from '../request'
import type { accoutType, phoneType } from '../../types/loginTypes'
import qs from 'query-string'

// 获取图片验证码
export function getCaptchaApi() {
  return request.get('/api/admin_user/verify_code')
}

// 账号登录
export function loginByAccoutApi(params: accoutType) {
  return request.post('/api/admin_user/login', params)
}

// 退出登录
export function getLoginOutApi() {
  return request.post('/api/admin_user/logout')
}

// 用户信息及权限
export function getUserPermissionApi(uid: any) {
  let query = qs.stringify({ uid })
  return request.get(`/api/admin_user/user_info?${query}`)
}

// 获取验证码
export function getPhoneCodeApi(params: phoneType) {
  return request.post('/admin/send_sms', params)
}